'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesTotals = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var fetchPagesTotals = exports.fetchPagesTotals = function fetchPagesTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      return (0, _client.get)('v1/event/' + (0, _params.getUID)(params.event) + '/pages').then(function (response) {
        return response.totalFundraisingPages;
      });
    case 'charity':
      // No API method supports total number of pages for a charity
      return (0, _params.required)();
    default:
      return _client.servicesAPI.get('/v1/justgiving/campaigns/' + (0, _params.getUID)(params.campaign) + '/leaderboard').then(function (response) {
        return response.data;
      }).then(function (data) {
        return data.meta.totalResults;
      });
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages-totals/justgiving/index.js
// module id = 1333
// module chunks = 0